import { clone } from 'lodash';
import { AlertMessageActions } from '~/actions/alertMessage';

// Defined empty state
/**
 * [
 *  {
 *    key: UserManagementActions.CREATE_USER,
 *    success: true,
 *    message: 'User already create'
 *  }
 * ]
 */
const initialState = [];

export default (state = initialState, action) => {
  const { type, ...param } = action;

  // `action.type`
  switch (type) {
    case AlertMessageActions.RESET:
      return clone([]);

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/reducers/alertMessage.js